import React from 'react';
import { Typography, useTheme } from '@mui/material';

import {
  getDashboardPanelTokens,
  TILE_TITLE_FONT_SIZE,
  TILE_TITLE_FONT_WEIGHT,
} from './dashboardPanelTokens';

interface TileHeadingProps {
  readonly children: React.ReactNode;
}

/**
 * A dashboard tile's heading.
 *
 * One component rather than the same nine-line `sx` block copied into every
 * tile -- which is how the sizes drifted to 18/700, 16/700 and 15/600 across
 * five tiles in the first place.
 */
export function TileHeading({ children }: Readonly<TileHeadingProps>) {
  const { palette } = useTheme();
  const tokens = getDashboardPanelTokens(palette.mode);

  return (
    <Typography
      component="h3"
      sx={{
        margin: 0,
        fontSize: TILE_TITLE_FONT_SIZE,
        fontWeight: TILE_TITLE_FONT_WEIGHT,
        lineHeight: 1.3,
        letterSpacing: '-0.01em',
        color: tokens.ink,
      }}
    >
      {children}
    </Typography>
  );
}
